"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var material_ui_image_1 = require("material-ui-image");
var financeAndInsuranceStyles_1 = require("./financeAndInsuranceStyles");
var FinanceAndInsuranceSummary_1 = require("../financeAndInsuranceSummary/FinanceAndInsuranceSummary");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var UpdateOrderButton_1 = require("../buttons/updateOrderButton/UpdateOrderButton");
var ContinueButton_1 = require("../buttons/continueButton/ContinueButton");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useImageFromAssets_1 = require("../../hooks/useImageFromAssets");
var FinanceAndInsurance = function () {
    var _a, _b, _c;
    var intl = react_intl_1.useIntl();
    var title = intl.formatMessage({ id: 'trans__checkout__next_step__order_now__finance_and_insurance_label' });
    var financeInsuranceLabel3 = intl.formatMessage({
        id: 'trans__checkout__next_step__finance_and_insurance_label3',
        defaultMessage: ' ',
    });
    var imgSrc = useImageFromAssets_1.default('finance-insurance');
    var styles = financeAndInsuranceStyles_1.default();
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var deal = useCheckoutContext_1.default().deal;
    var insuranceIntegration = usePlatformConfig_1.default().platformConfig.platformFeatures.insuranceIntegration;
    var hasFinance = !!(((_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.finance) === null || _b === void 0 ? void 0 : _b.type) === globalTypes_1.FinanceFormType.finance);
    var hasInsurance = !!((_c = deal) === null || _c === void 0 ? void 0 : _c.insurance);
    var renderUpdateOrderButton = function () {
        if (hasFinance && ((insuranceIntegration && hasInsurance) || !insuranceIntegration)) {
            return null;
        }
        return <UpdateOrderButton_1.default />;
    };
    return (<core_1.Box data-test={'checkout:finance_insurance'}>
      <FinanceAndInsuranceSummary_1.default className={styles.summaryLabel}/>
      <core_1.Grid spacing={2} container className={styles.container}>
        <core_1.Grid item sm={12} md={4} className={styles.imageRoot}>
          <material_ui_image_1.default src={imgSrc} color="transparent" className={styles.image} imageStyle={{
        position: isMobile ? 'relative' : 'absolute',
        height: isMobile ? 230 : 'unset',
    }} style={{
        paddingTop: isMobile ? 0 : '56.25%',
        height: isMobile ? 'auto' : 0,
    }} animationDuration={0} alt={title} data-test={'checkout:finance_insurance:image'}/>
        </core_1.Grid>
        <core_1.Grid item sm={12} md={8} data-test={'checkout:finance_insurance:details'}>
          <core_1.Typography className={styles.details}>
            <Translation_1.default id={'trans__checkout__next_step__finance_and_insurance_label2'}/>
          </core_1.Typography>
          <core_1.Typography className={styles.financeDetails} dangerouslySetInnerHTML={{ __html: financeInsuranceLabel3 }}/>
        </core_1.Grid>
      </core_1.Grid>
      <core_1.Box className={styles.buttonsWrapper}>
        <ContinueButton_1.default testId="checkout:continue_button:finance_and_insurance" activateNextStep={true}/>
        {renderUpdateOrderButton()}
      </core_1.Box>
    </core_1.Box>);
};
exports.default = FinanceAndInsurance;
